import axios from 'axios';

const luckyWheelClient = axios.create({
    withCredentials: true
});
luckyWheelClient.interceptors.response.use(response => response.data);

luckyWheelClient.interceptors.request.use(config => {
    config.baseURL = '/api/luckywheel';
    return config;
});

export default luckyWheelClient;
